/* eslint-disable sort-keys-fix/sort-keys-fix */
import { Loader, truthy } from "@quortex/front-common"
import { type DefaultGenerics, Outlet, type Route } from "@tanstack/react-location"
import { lazy } from "react"
import { switchRoutes } from "@/routes-switch"

// Misc
const Root = lazy(() => import("./App/Root"))

const Organization = lazy(() =>
  import("@quortex/front-common").then(module => ({ default: module.Organization }))
)

const NotFound = lazy(() =>
  import("@quortex/front-common").then(module => ({ default: module.NotFound }))
)

export const portalRoutes: Route<DefaultGenerics> = {
  path: "/",
  element: <Root />,
  children: [
    // Organization-less landing pages
    {
      path: "/link",
      element: <Loader isFullPage />
    },
    {
      path: "/play",
      element: <Loader isFullPage />
    },
    {
      path: "/switch",
      element: <Loader isFullPage />
    },
    {
      path: "organizations/:orgUuid",
      element: (
        <Organization>
          <Outlet />
        </Organization>
      ),
      children: [
        // App routes
        ...switchRoutes,
        { element: <NotFound /> }
      ]
    }
  ].filter(truthy)
}
